export const getApproverData = (approver, levelDetails) => {
    if (!approver && !levelDetails) return '';

    const approverInfo = levelDetails?.approver?.approver;

    if (levelDetails?.approver?.approverType === 1
        || (!levelDetails && approver.approverType === 1)) {
        return approverInfo?.email || approver.emailOfVendor || '';
    }

    const name = approverInfo?.name;
    const email = approverInfo?.email;

    return levelDetails?.approver?.approverType === 2 && name && email ? `${name} (${email})` : email;
};

export const initializeApproverLevel = (level, initiatedDetails, levelIndex) => {
    if (!level && !initiatedDetails) {
        return {
            dynamicLabel: 'Vendor',
            type: 'dropdown',
            options: [],
            users: [],
            email: '',
            status: ''
        };
    }

    const shortCloseLDetails = initiatedDetails?.shortCloseLevelDetails || null;
    const levelKey = `level${levelIndex}`;
    const approverData = getApproverData(level, shortCloseLDetails?.[levelKey]);
    let dynamicLabel = 'Vendor';
    if (shortCloseLDetails?.[levelKey]) {
        dynamicLabel = shortCloseLDetails?.[levelKey]?.approver?.roleIdentifier || 'Vendor';
    } else {
        dynamicLabel = level?.roleIdentifier || 'Vendor';
    }
    return {
        dynamicLabel,
        type:
            shortCloseLDetails?.[levelKey]
                ? 'vendor'
                : level?.approverType === 1
                    ? 'vendor'
                    : 'dropdown',
        options: (level?.users || []).map((user) => ({
            label: `${user?.name || ''} (${user?.email || ''})`,
            value: user?.id || ''
        })),
        approverType: shortCloseLDetails?.[levelKey]?.approver?.approverType || level?.approverType,
        users: level?.users || [],
        email: approverData,
        status: shortCloseLDetails?.[levelKey]?.status || ''
    };
};

export const getInitialValues = (
    approvalConfig,
    reasonOptions = [],
    level1Email = '',
    level2Email = '',
    dynamicLabel1 = '',
    dynamicLabel2 = ''
) => {
    const isInitiated = approvalConfig?.shortCloseInitiatedDetails?.isShortCloseInitiated;
    const initiatedDetails = approvalConfig?.shortCloseInitiatedDetails || {};
    const reason = isInitiated ? initiatedDetails?.reasonId : '';

    const reasonObj = reasonOptions?.find((r) => r?.value === reason);
    const otherReason = reasonObj?.label === 'Other' ? initiatedDetails?.otherReason || '' : '';

    return {
        reason: reason || '',
        otherReason,
        level1Assignee: level1Email || '',
        level2Assignee: level2Email || '',
        remarks: initiatedDetails?.remarks || '',
        level1RoleIdentifier: dynamicLabel1 || '',
        level2RoleIdentifier: dynamicLabel2 || ''
    };
};

export const preparePayload = (
    values = {},
    level1Type,
    level1Users = [],
    level2Type,
    level2Users = [],
    reasonOptions = [],
    approvalConfig = {}
) => {
    const level1Approver = level1Type === 'vendor'
        ? level1Users[0] : level1Users.find((user) => user?.id === values.level1Assignee);

    const payload = {
        ...values,
        level1Assignee: level1Approver || null
    };

    if (reasonOptions.find((r) => r?.value === payload.reason)?.label !== 'Other') {
        delete payload.otherReason;
    }

    if (approvalConfig.numberOfLevels === 2) {
        const level2Approver = level2Type === 'vendor'
            ? level2Users[0]
            : level2Users.find((user) => user?.id === values.level2Assignee);
        payload.level2Assignee = level2Approver || null;
        payload.level2RoleIdentifier = values.level2RoleIdentifier || '';
    } else {
        delete payload.level2Assignee;
        delete payload.level2RoleIdentifier;
    }

    return payload;
};

export const updateApproverEmail = (approverLevels, updatedEmail) => {
    if (!approverLevels || typeof approverLevels !== 'object') return approverLevels;

    return Object.fromEntries(
        Object.entries(approverLevels).map(([key, value]) => {
            if (value?.approverType === 1) {
                return [
                    key,
                    {
                        ...value,
                        email: updatedEmail
                    }
                ];
            }
            return [key, value];
        })
    );
};
